import { format, parseISO, differenceInYears, parse } from 'date-fns'
import isEqual from 'date-fns/isEqual'
import { enUS, es } from 'date-fns/esm/locale'

var dateLocales = { es: es, en: enUS }

export function stringToDate(cadena) {
  return format(parseISO(cadena), 'dd/MM/yyyy')
} 

export function stringToDateDetail(cadena) {
  // console.log(cadena, new Date(cadena));
  return format(parseISO(cadena), "dd 'de' MMM yyyy", {locale: dateLocales.es})
} 

export function stringToDateDistance(cadena) {
  return format(parseISO(cadena), 'MM/dd/yyyy')
} 

export function stringToDateText(cadena) {
  return format(parseISO(cadena), 'EEEE dd', {locale: dateLocales.es})
}

export function stringToDayText(cadena) {
  return format(parseISO(cadena), 'EEEE', {locale: dateLocales.es})
} 

export function  calculateAge(cadena) {
  const age = differenceInYears(new Date(), new Date(cadena))
  return age
}

export function isEqualDates(date1, date2) {
  return isEqual(date1, date2)
}